export default __webpack_public_path__ + "static/media/EssayPage.ad98d454.png";